//@flow
import * as React from 'react';
import {baseClass} from "../../../../pages/UiKit/newUiKit/utilities/baseClass";
import type {children, id} from "../../../../services/flowTypes/appFlowTypes";
import type {addClasses} from "../../../../services/flowTypes/uiKitFlowTypes";
import './ContentPlaceholder.css';

type Props = {
  id?: id,
  addClasses?: addClasses,
  children: children
};

const ContentPlaceholder = (props: Props) => {
  return (
    <div id={props.id} className={baseClass("ContentPlaceholder", props.addClasses)}>
      <div className="ContentPlaceholder__placeholder">
        <div className="ContentPlaceholder__animated-background"></div>
      </div>
    </div>
  );
};

export default ContentPlaceholder;